/**
 * @module
 * @format
 */

// @ts-ignore deprecated Stargazer export
import {COMPILE, SCOPE, UPGRADE, NodeUpgrade} from '@acng/frontend-stargazer';
import {size} from '@acng/frontend-bounty/std/array.js';

/**
 * @import {Controller, InternalEngine as Engine} from "@acng/frontend-stargazer";
 * @import {Amateur} from "../amateurPool/model/amateur.js";
 * @import {FeedItemType} from './types';
 */

import {Actor} from '../layout/context/list.js';
import {STYLE_EMPTY, swapClass} from '../layout/service/style.js';
import {STYLE_INIT} from '../layout/style/flags.js';
import {FEED_TYPE_WEBLOG} from '../model';
import {fetchAmateurFeed} from './store.js';

const provideList = Actor();

/**
 * @implements {Controller}
 */
class AmateurFeedList {
  #amateur;
  #type;

  /**
   * @param {Amateur} amateur
   * @param {FeedItemType} [type]
   */
  constructor(amateur, type) {
    this.#amateur = amateur;
    this.#type = type;
  }

  /**
   * @param {Element} element
   */
  [UPGRADE](element) {
    let isEmpty = false;

    swapClass(element, STYLE_INIT, true);

    provideList(
      element,
      async (offset) => {
        if (isEmpty || offset) {
          return [];
        }

        const {id} = this.#amateur;
        const feed = await fetchAmateurFeed(id, this.#type);

        isEmpty = swapClass(element, STYLE_EMPTY, !size(feed));
        swapClass(element, STYLE_INIT, false);

        return feed;
      },
      async (item) => {
        await item[COMPILE]();

        /**
         * @param {Element} element
         * @param {Engine} engine
         */
        return (element, engine) => {
          item[UPGRADE](element);
          NodeUpgrade(engine, item[SCOPE]);
        };
      },
    );
  }
}

class AmateurFeed {
  /**
   * @param {Amateur} amateur
   */
  constructor(amateur) {
    this.all = new AmateurFeedList(amateur);
    this.weblog = new AmateurFeedList(amateur, FEED_TYPE_WEBLOG);
  }
}

export {AmateurFeed};
